import * as React from "react";
import { forwardRef } from "react";
const SvgSuitDiamonds = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 260" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g transform="translate(-288.15635,-348.0625)"><path id="path3200" d="M 408.15635,352.45099 C 385.76859,400.21284 352.76072,442.26342 308.15635,478.0625 C 352.76072,513.86156 385.76859,555.91215 408.15635,603.674 C 430.54411,555.91215 463.55198,513.86156 508.15635,478.0625 C 463.55198,442.26342 430.54411,400.21284 408.15635,352.45099 z" style={{
      fill: "#dd1a1e",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.5,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeMiterlimit: 3.9994173,
      strokeDasharray: "none",
      strokeOpacity: 1
    }} /></g></svg>;
const ForwardRef = forwardRef(SvgSuitDiamonds);
export default ForwardRef;